<template>
  <div>
    <!-- todo - https://stackoverflow.com/questions/50392918/vuetify-how-to-preselect-active-tab
     -->
    <v-tabs v-model="activetab" align-with-title class="mt-n2 pb-0 tab-headers-details">
      <!-- eslint-disable-next-line max-len -->
      <v-tab v-for="tab of tabs" class="common-font-size" :key="tab.id" @click="WarnUser(tab.to)" :id="`mtgTransSequenceTab${tab.id}`"
        :class="`mtg-trans-sequence-tab-${tab.id}`">
        <span>{{ tab.caption }}</span>
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import CommonDropDownsMixin from '../components/tax/common-utils/CommonDropDowns.mixin.vue';
import '../assets/style.css';
import { transformMapperListFields } from '../util/shared/transform';

export default {
  name: 'SpecialtaxItems',
  mixins: [CommonDropDownsMixin],
  components: {
  },
  created() {
    this.getPathName();
    this.loadDropDownList();
  },
  updated() {
    this.getPathName();
  },
  data: () => ({
    dialog: false,
    path: '',
    activetab: 0,
    tabs: [
      { id: 1, to: { path: '/tax/specialTaxItems/protestedTax' }, caption: 'Protested Tax' },
      { id: 2, to: { path: '/tax/specialTaxItems/exemptMfg' }, caption: 'Exempt Manufacturing' },
      { id: 3, to: { path: '/tax/specialTaxItems/tifDistricts' }, caption: 'TIF Districts' },
      { id: 4, to: { path: '/tax/specialTaxItems/newTaxRoll/importandbalance' }, caption: 'New Tax Roll' },
    ],
  }),
  methods: {
    ...mapActions('config', [
      'loadTransformMappers',
    ]),
    loadDropDownList() {
      const criteria = { type: 'import', program: 'TAX' };
      this.loadTransformMappers({
        criteria,
        fields: { ...transformMapperListFields },
        baseCrudKey: 'transform-mapper-list',
      });
      this.loadTaxDistrict({
        criteria: {
          sortBy: [{
            column: 'districtCode',
            direction: 'asc',
          }],
        },
        baseCrudKey: 'sharedTaxDistrict',
      });
      this.loadTaxYearList({ postProcessTrans: this.postProccessTaxYearData });
    },
    getPathName() {
      const curPath = this.$route.path;
      const ftr = this.tabs.filter((ft) => ft.to.path === curPath);
      if (ftr.length) this.activetab = ftr[0].id - 1;
      else if (curPath.includes('newTaxRoll')) this.activetab = 3;
      else this.activetab = 0;
    },
    WarnUser(path) {
      this.path = path;
      const currentpath = this.$router.currentRoute.path;
      if (path.path !== currentpath) {
        this.$router.push(path);
      }
    },
  },

};
</script>
